import { z } from 'zod';

import { apiClient } from './client';

const achievementSchema = z.object({
  id: z.string().min(1),
  familyId: z.string().min(1),
  iconKey: z.string(),
  ownersCount: z.number().int().nonnegative(),
  title: z.string(),
  description: z.string(),
  tier: z.number().int().nonnegative(),
  progress: z.number().nonnegative(),
  threshold: z.number().nonnegative(),
  status: z.string(),
  unlockedAt: z.string().nullish(),
  reward: z.object({ exp: z.number().nonnegative(), coins: z.number().nonnegative() }),
});

export const achievementsApi = {
  async list() {
    const response = z.object({ achievements: z.array(achievementSchema) }).parse(await apiClient.achievements.list());
    return response.achievements.map((item) => ({ ...item, unlockedAt: item.unlockedAt ?? undefined }));
  },
};
